module.exports = __webpack_public_path__ + "static/media/accessory__motor.98ecc9ac.jpg";